import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Red Hat Ansible I (DO407) Training in Pune</h1>
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/ansible.png")} alt="" />
          </div>
          <div className="heading">
            <h3>Automation with Ansible I (DO407)</h3>
            <p>
              Automation with Ansible I (DO407) is designed for system
              administrators who are intending to use Ansible for automation,
              configuration, and management. Learn how to install and configure
              Ansible, create and run playbooks to configure systems, and learn
              to manage inventories. This course is based on Red Hat® Enterprise
              Linux® 7.
            </p>

            <h3>Course overview</h3>
            <p>
              Through hands-on labs, students will learn to automate system
              administration tasks on managed hosts with Ansible, learn how to
              write Ansible playbooks to standardize task execution, centrally
              manage playbooks and schedule recurring execution through a web
              interface with Red Hat® Ansible Tower. Students will also learn to
              manage encryption for Ansible with Ansible Vault, deploy Ansible
              Tower and use it to manage systems, and use Ansible in a DevOps
              environment with Vagrant
            </p>
            <br/>
            {/*  */}
            <h4>1. Introduction to Ansible I </h4>
            <ul>
              <li>Introduction to Configuration management. </li>
              <li>Difference  between chef / ansible / puppet / saltstack / bash scripting  </li>
              <li>Architecture of Ansible </li>
              <li>Ansible modules   </li>
              <li>Ansible inventory ( static and Dynamic )  </li>
              <li>Ansible Use cases. </li>
            </ul>
            {/*  */}
            <h4>
            2. Deploying Ansible  
            </h4>
            <ul>
              <li>Installing Ansible </li>
              <li>Running Ad-hoc commands  </li>
              <li>Managing static and dynamic inventories </li>
              <li>creating own ansible.cfg file </li>
            </ul>
            {/*  */}

            <h4>
            3. Writing playbooks
            </h4>
            <ul>
              <li>Introduction to YAML  </li>
              <li>Implementing modules </li>
              <li>writing Playbooks </li>
              <li>Sample playbooks </li>
              <li>Configuring LAMP stack Using Ansible </li>
              <li>Deploy nginx web application </li>
            </ul>
            {/*  */}
            <h4>
            4. Managing variables
            </h4>
            <ul>
              <li>Defining variables  </li>
              <li>Ansible facts </li>
              <li>Using Facts in playbooks </li>
              <li>managing inclusion of variables through different files </li>
            </ul>
            {/*  */}

            <h4>
            5.  Special Topics
            </h4>
            <ul>
              <li>Introduction to handlers </li>
              <li>Using handlers in playbooks </li>
              <li>Ansible tags </li>
              <li>Errror Handling </li>
              <li>complex playbooks </li>
              <li>Loops in Ansible </li>
              <li>Conditional statements </li>
            </ul>
            {/*  */}

            <h4>
            6. Ansible Roles
            </h4>
            <ul>
              <li>Creating Roles  </li>
              <li>implementing Roles </li>
              <li>Ansible-galaxy </li>
            </ul>
            {/*  */}

            <h4>
            7. Optimizing Ansible
            </h4>
            <ul>
              <li>configuring connection types </li>
              <li>configuring Delegation </li>
              <li>configuring parallelism </li>
              <li>Troubleshooting Playbooks </li>
            </ul>
            {/*  */}

            <h4>
            8. Ansible Vault
            </h4>
            <ul>
              <li>securing playbooks using ansible-vault </li>
              <li>running playbook using ansible-vault </li>
              <li>Using Ansible with Vagrant. </li>
              <li>Provisioning vagrant machines. </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
